import _assertThisInitialized from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _extends from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _classCallCheck from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _defineProperty from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import hoistStatics from 'hoist-non-react-statics';
import { withNavigation } from '@react-navigation/core';
export default function createNavigationAwareScrollable(Component) {
  var _class, _temp;

  var ComponentWithNavigationScrolling = withNavigation((_temp = _class =
  /*#__PURE__*/
  function (_React$PureComponent) {
    _inherits(_class, _React$PureComponent);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
    }

    _createClass(_class, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this = this;

        this._subscription = this.props.navigation.addListener('refocus', function () {
          var scrollableNode = _this.getNode();

          if (_this.props.navigation.isFocused() && scrollableNode !== null) {
            if (scrollableNode.scrollToTop != null) {
              scrollableNode.scrollToTop();
            } else if (scrollableNode.scrollTo != null) {
              scrollableNode.scrollTo({
                y: 0
              });
            } else if (scrollableNode.scrollResponderScrollTo != null) {
              scrollableNode.scrollResponderScrollTo({
                y: 0
              });
            }
          }
        });
      }
    }, {
      key: "getNode",
      value: function getNode() {
        if (this._scrollRef === null) {
          return null;
        }

        if (this._scrollRef.getScrollResponder) {
          return this._scrollRef.getScrollResponder();
        } else if (this._scrollRef.getNode) {
          return this._scrollRef.getNode();
        } else {
          return this._scrollRef;
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this._subscription != null) {
          this._subscription.remove();
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        return React.createElement(Component, _extends({
          ref: function ref(view) {
            _this2._scrollRef = view;
          }
        }, this.props));
      }
    }]);

    return _class;
  }(React.PureComponent), _defineProperty(_class, "displayName", "withNavigationScrolling(".concat(Component.displayName || Component.name, ")")), _temp));

  var NavigationAwareScrollable =
  /*#__PURE__*/
  function (_React$PureComponent2) {
    _inherits(NavigationAwareScrollable, _React$PureComponent2);

    function NavigationAwareScrollable() {
      var _getPrototypeOf2;

      var _this3;

      _classCallCheck(this, NavigationAwareScrollable);

      for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
        _args[_key] = arguments[_key];
      }

      _this3 = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(NavigationAwareScrollable)).call.apply(_getPrototypeOf2, [this].concat(_args)));

      _defineProperty(_assertThisInitialized(_this3), "_captureRef", function (view) {
        _this3._innerRef = view;
        _this3.props.onRef && _this3.props.onRef(view);
      });

      _defineProperty(_assertThisInitialized(_this3), "setNativeProps", function () {
        var _this3$_innerRef$getN;

        return (_this3$_innerRef$getN = _this3._innerRef.getNode()).setNativeProps.apply(_this3$_innerRef$getN, arguments);
      });

      _defineProperty(_assertThisInitialized(_this3), "getScrollResponder", function () {
        var _this3$_innerRef$getN2;

        return (_this3$_innerRef$getN2 = _this3._innerRef.getNode()).getScrollResponder.apply(_this3$_innerRef$getN2, arguments);
      });

      _defineProperty(_assertThisInitialized(_this3), "getScrollableNode", function () {
        var _this3$_innerRef$getN3;

        return (_this3$_innerRef$getN3 = _this3._innerRef.getNode()).getScrollableNode.apply(_this3$_innerRef$getN3, arguments);
      });

      _defineProperty(_assertThisInitialized(_this3), "getInnerViewNode", function () {
        var _this3$_innerRef$getN4;

        return (_this3$_innerRef$getN4 = _this3._innerRef.getNode()).getInnerViewNode.apply(_this3$_innerRef$getN4, arguments);
      });

      _defineProperty(_assertThisInitialized(_this3), "scrollTo", function () {
        var _this3$_innerRef$getN5;

        return (_this3$_innerRef$getN5 = _this3._innerRef.getNode()).scrollTo.apply(_this3$_innerRef$getN5, arguments);
      });

      _defineProperty(_assertThisInitialized(_this3), "scrollToEnd", function () {
        var _this3$_innerRef$getN6;

        return (_this3$_innerRef$getN6 = _this3._innerRef.getNode()).scrollToEnd.apply(_this3$_innerRef$getN6, arguments);
      });

      _defineProperty(_assertThisInitialized(_this3), "scrollWithoutAnimationTo", function () {
        var _this3$_innerRef$getN7;

        return (_this3$_innerRef$getN7 = _this3._innerRef.getNode()).scrollWithoutAnimationTo.apply(_this3$_innerRef$getN7, arguments);
      });

      _defineProperty(_assertThisInitialized(_this3), "flashScrollIndicators", function () {
        var _this3$_innerRef$getN8;

        return (_this3$_innerRef$getN8 = _this3._innerRef.getNode()).flashScrollIndicators.apply(_this3$_innerRef$getN8, arguments);
      });

      return _this3;
    }

    _createClass(NavigationAwareScrollable, [{
      key: "render",
      value: function render() {
        return React.createElement(ComponentWithNavigationScrolling, _extends({}, this.props, {
          onRef: this._captureRef
        }));
      }
    }]);

    return NavigationAwareScrollable;
  }(React.PureComponent);

  _defineProperty(NavigationAwareScrollable, "displayName", "NavigationAwareScrollable(".concat(Component.displayName || Component.name, ")"));

  return hoistStatics(NavigationAwareScrollable, Component);
}